// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2I_Ve","errorContainer":"styles_errorContainer__GeBsM","form":"styles_form__2zTa9","buttonContainer":"styles_buttonContainer__KaFKv"};